<template>
    <div class="font-inter w- h-[1040px] bg-[#FFFFFF] rounded-t-[20px] mt-3">

      <div class="bg-[#FBFCFC] h-[720px]">
      <div class="space-y-7">
          <!-- Add margin-top to this div or the img -->
          <div class="w-[174px] h-[174px] bg-primaryLight rounded-full mx-auto flex items-center justify-center">
          <img src="@/assets/hourglass.svg" alt="User icon" class="h-[84px]">
          </div>
          <div class="flex items-center justify-center">
          <div class="text-center w-[444px] bg-[#FFFFFF] border border-grayLight p-6 rounded-lg shadow-md">
              <div class="space-y-6">
              <p class="font-bold text-[24px] text-grayDark">Your account is pending approval</p>
              <p class="text-gray-500">
                  Thank you for signing up! Keep an eye on your inbox; your account is currently being reviewed and will be approved within 1-2 business days.
              </p>
              </div>
              <p class="text-gray-500 mt-4">
              In the meantime, feel free to explore our website. If you have any questions, please contact support@ourcompany.com.
              </p>
          </div>
          </div>
      </div>
      </div>        
    </div>

</template>
  
  
  
<script>
  import { useRouter } from 'vue-router'
  
  export default {
    name: 'AwaitingApproval',
    data() {
      return {
      }
    },
    components: {
    },
    setup() {
      const router = useRouter()
      return { router }
    },
    methods: {
    },
    mounted() {
      window.scrollTo(0, 0);
    },
  }
</script>
<style scoped>

</style>
    
      